/* ═══════════════════════════════════════════════════════
   STUNTING.ID — UI, interaksi & kalkulator
   ═══════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var D = window.SITE_DATA;
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var clamp = function (v, a, b) { return Math.min(b, Math.max(a, v)); };
  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ═══════════ PRELOADER ═══════════ */
  (function preloader() {
    var el = $('#preloader'), pct = $('#loadPct'), ring = $('#ringFill');
    if (!el) return;   // tanpa preloader, kickReveal dipanggil di akhir berkas
    var p = 0, done = false, C = 327;

    function set(v) {
      p = clamp(v, 0, 100);
      pct.textContent = Math.round(p);
      ring.style.strokeDashoffset = C - (C * p) / 100;
    }
    var timer = setInterval(function () {
      if (done) return;
      set(p + (p < 60 ? 6 : p < 88 ? 2 : 0.4));
      if (p >= 96) clearInterval(timer);
    }, 90);

    function finish() {
      if (done) return;
      done = true;
      clearInterval(timer);
      set(100);
      setTimeout(function () {
        el.classList.add('done');
        document.body.classList.remove('is-locked');
        setTimeout(function () { el.remove(); }, 800);
        kickReveal();
      }, 420);
    }
    document.body.classList.add('is-locked');
    window.addEventListener('scenes-ready', finish);
    window.addEventListener('load', function () { setTimeout(finish, 2200); });
    setTimeout(finish, 6500); // jaring pengaman
  })();

  /* ═══════════ CURSOR ═══════════ */
  (function cursor() {
    var c = $('#cursor'), d = $('#cursorDot');
    if (!c || window.matchMedia('(pointer:coarse)').matches) return;
    var x = 0, y = 0, tx = 0, ty = 0;
    window.addEventListener('pointermove', function (e) {
      tx = e.clientX; ty = e.clientY;
      d.style.transform = 'translate(' + tx + 'px,' + ty + 'px)';
    }, { passive: true });
    (function raf() {
      x += (tx - x) * 0.18; y += (ty - y) * 0.18;
      c.style.transform = 'translate(' + x + 'px,' + y + 'px)';
      requestAnimationFrame(raf);
    })();
    document.addEventListener('pointerover', function (e) {
      var t = e.target.closest('a,button,input,label,.qopt,.check,.myth,.cause,.rank li,canvas');
      c.classList.toggle('grow', !!t);
    });
  })();

  /* ═══════════ SCROLL: progress, nav, spy ═══════════ */
  (function scrollFx() {
    var bar = $('#scrollBar'), nav = $('#nav');
    var links = $$('[data-nav]');
    var secs = links.map(function (a) { return $(a.getAttribute('href')); }).filter(Boolean);
    var ticking = false;

    function update() {
      var h = document.documentElement.scrollHeight - window.innerHeight;
      var sc = window.scrollY;
      if (bar) bar.style.width = (h > 0 ? (sc / h) * 100 : 0) + '%';
      if (nav) nav.classList.toggle('scrolled', sc > 40);

      var mid = sc + window.innerHeight * 0.35, active = -1;
      secs.forEach(function (s, i) { if (s && s.offsetTop <= mid) active = i; });
      links.forEach(function (a, i) { a.classList.toggle('active', i === active); });
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true });
    update();
  })();

  /* ═══════════ NAV MOBILE ═══════════ */
  (function mobileNav() {
    var b = $('#burger'), menu = $('#navLinks');
    if (!b) return;
    b.addEventListener('click', function () {
      var open = menu.classList.toggle('open');
      b.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    menu.addEventListener('click', function (e) {
      if (e.target.tagName === 'A') {
        menu.classList.remove('open');
        b.setAttribute('aria-expanded', 'false');
      }
    });
  })();

  /* ═══════════ REVEAL + COUNTER ═══════════ */
  var revealObs = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      e.target.classList.add('in');
      $$('[data-count]', e.target).forEach(runCounter);
      if (e.target.hasAttribute('data-count')) runCounter(e.target);
      revealObs.unobserve(e.target);
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

  function kickReveal() {
    $$('.reveal, .tl-item').forEach(function (el) { revealObs.observe(el); });
  }

  function runCounter(el) {
    if (el.dataset.done) return;
    el.dataset.done = '1';
    var to = parseFloat(el.dataset.count) || 0;
    var dec = parseInt(el.dataset.dec || '0', 10);
    var suffix = el.dataset.suffix || '';
    if (REDUCED) { el.textContent = to.toFixed(dec) + suffix; return; }
    var dur = 1500, t0 = performance.now();
    (function step(now) {
      var k = clamp((now - t0) / dur, 0, 1);
      var e = 1 - Math.pow(1 - k, 3);
      el.textContent = (to * e).toFixed(dec) + (k === 1 ? suffix : '');
      if (k < 1) requestAnimationFrame(step);
    })(t0);
  }

  /* ═══════════ TOMBOL MAGNETIS ═══════════ */
  (function magnetic() {
    if (window.matchMedia('(pointer:coarse)').matches || REDUCED) return;
    $$('[data-magnetic]').forEach(function (el) {
      el.addEventListener('pointermove', function (e) {
        var r = el.getBoundingClientRect();
        var dx = e.clientX - (r.left + r.width / 2);
        var dy = e.clientY - (r.top + r.height / 2);
        el.style.transform = 'translate(' + dx * 0.16 + 'px,' + dy * 0.24 + 'px)';
      });
      el.addEventListener('pointerleave', function () { el.style.transform = ''; });
    });
  })();

  /* ═══════════ SEKSI: SIMULASI TINGGI ═══════════ */
  (function growthPanel() {
    var range = $('#ageRange');
    if (!range) return;
    var out = $('#ageOut'), hN = $('#hNormal'), hS = $('#hStunt'), hG = $('#hGap');

    function fmtAge(m) {
      if (m === 0) return 'Baru lahir';
      if (m < 12) return m + ' bulan';
      var y = Math.floor(m / 12), r = m % 12;
      return y + ' tahun' + (r ? ' ' + r + ' bln' : '');
    }

    function apply() {
      var m = +range.value;
      range.style.setProperty('--p', (m / 60) * 100 + '%');
      out.textContent = fmtAge(m);

      // rata-rata laki-laki & perempuan agar netral gender
      var rM = D.whoRef('M', m), rF = D.whoRef('F', m);
      var median = (rM.median + rF.median) / 2;
      var sd = (rM.sd + rF.sd) / 2;
      var stunted = median - 2 * sd;

      hN.textContent = median.toFixed(1);
      hS.textContent = stunted.toFixed(1);
      hG.textContent = (median - stunted).toFixed(1);

      window.dispatchEvent(new CustomEvent('age-change', { detail: { months: m } }));
    }
    range.addEventListener('input', apply);
    apply();
  })();

  /* ═══════════ SEKSI: PETA / PERINGKAT ═══════════ */
  (function mapPanel() {
    var high = $('#rankHigh'), low = $('#rankLow');
    if (!high) return;

    var sorted = D.PROVINCES.slice().sort(function (a, b) { return b.v - a.v; });
    var max = sorted[0].v;

    function row(p, i) {
      var li = document.createElement('li');
      li.innerHTML =
        '<i>' + String(i + 1).padStart(2, '0') + '</i>' +
        '<div><span>' + p.n + '</span><u><b style="width:' + (p.v / max) * 100 + '%"></b></u></div>' +
        '<em>' + p.v.toFixed(1) + '</em>';
      li.addEventListener('mouseenter', function () {
        window.dispatchEvent(new CustomEvent('focus-province', { detail: { name: p.n } }));
      });
      return li;
    }
    sorted.slice(0, 6).forEach(function (p, i) { high.appendChild(row(p, i)); });
    sorted.slice(-6).reverse().forEach(function (p, i) { low.appendChild(row(p, i)); });

    var nat = $('#natVal');
    if (nat) { nat.dataset.count = D.NATIONAL; nat.dataset.dec = '1'; revealObs.observe(nat); }
  })();

  /* ═══════════ SEKSI: PENYEBAB ═══════════ */
  (function causes() {
    var grid = $('#causeGrid');
    if (!grid) return;
    D.CAUSES.forEach(function (c) {
      var el = document.createElement('article');
      el.className = 'cause reveal';
      el.innerHTML =
        '<div class="cause__icon"><svg viewBox="0 0 24 24" fill="none">' + c.icon + '</svg></div>' +
        '<h4>' + c.t + '</h4><p>' + c.d + '</p>' +
        '<div class="cause__stat">' + c.s + '</div>';
      el.addEventListener('pointermove', function (e) {
        var r = el.getBoundingClientRect();
        el.style.setProperty('--mx', ((e.clientX - r.left) / r.width) * 100 + '%');
        el.style.setProperty('--my', ((e.clientY - r.top) / r.height) * 100 + '%');
      });
      grid.appendChild(el);
    });
  })();

  /* ═══════════ SEKSI: TIMELINE ═══════════ */
  (function timeline() {
    var tl = $('#timeline');
    if (!tl) return;
    D.TIMELINE.forEach(function (item, i) {
      var el = document.createElement('div');
      el.className = 'tl-item';
      el.style.transitionDelay = (i * 0.06) + 's';
      el.innerHTML =
        '<div class="tl-item__dot">' + item.dot + '</div>' +
        '<div class="tl-item__card">' +
          '<span class="tl-item__phase">' + item.phase + '</span>' +
          '<h4>' + item.t + '</h4><p>' + item.d + '</p>' +
          '<div class="tl-item__tags">' + item.tags.map(function (t) { return '<span>' + t + '</span>'; }).join('') + '</div>' +
        '</div>';
      tl.appendChild(el);
    });
  })();

  /* ═══════════ SEKSI: GIZI ═══════════ */
  (function nutrients() {
    var tabs = $('#nutriTabs'), detail = $('#nutriDetail'), formula = $('#nutriFormula');
    if (!tabs) return;

    function render(n) {
      formula.innerHTML = n.formula;
      detail.innerHTML =
        '<div>' +
          '<h3><i style="background:' + n.color + ';color:' + n.color + '"></i>' + n.name + '</h3>' +
          '<p style="font-size:.78rem;color:var(--txt-3);margin-top:.35rem">' + n.sub + '</p>' +
        '</div>' +
        '<p>' + n.role + '</p>' +
        '<div class="nutri-need"><b>' + n.need + '</b><span>' + n.needNote + '</span></div>' +
        '<div class="nutri-block"><h5>Sumber pangan</h5><div class="chiplist">' +
          n.sources.map(function (s) { return '<span class="chip">' + s + '</span>'; }).join('') +
        '</div></div>';
      window.dispatchEvent(new CustomEvent('nutrient-change', { detail: { id: n.id } }));
    }

    D.NUTRIENTS.forEach(function (n, i) {
      var b = document.createElement('button');
      b.className = 'nutri-tab' + (i === 0 ? ' active' : '');
      b.type = 'button';
      b.setAttribute('role', 'tab');
      b.textContent = n.name;
      b.addEventListener('click', function () {
        $$('.nutri-tab', tabs).forEach(function (x) { x.classList.remove('active'); });
        b.classList.add('active');
        render(n);
      });
      tabs.appendChild(b);
    });
    render(D.NUTRIENTS[0]);
  })();

  /* ═══════════ SEKSI: ISI PIRINGKU ═══════════ */
  (function plate() {
    var slices = $$('.pw'), legend = $$('.plate__legend li');
    if (!slices.length) return;
    function focus(key) {
      slices.forEach(function (s) {
        var on = !key || s.dataset.slice === key;
        s.classList.toggle('dim', !on);
        s.classList.toggle('pop', !!key && on);
      });
    }
    slices.concat(legend).forEach(function (el) {
      el.addEventListener('mouseenter', function () { focus(el.dataset.slice); });
      el.addEventListener('mouseleave', function () { focus(null); });
    });
  })();

  /* ═══════════ KALKULATOR ═══════════ */
  (function calculator() {
    var form = $('#calcForm');
    if (!form) return;

    var elAge = $('#cAge'), elH = $('#cHeight'), elName = $('#cName');
    var err = $('#calcError'), empty = $('#calcEmpty'), out = $('#calcOut');

    function fail(msg) {
      err.textContent = msg;
      err.hidden = false;
      return false;
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      err.hidden = true;

      var sex = ($('input[name=sex]:checked') || {}).value || 'M';
      var age = parseFloat(elAge.value);
      var h = parseFloat(elH.value);

      if (isNaN(age)) return fail('Umur anak belum diisi.');
      if (age < 0 || age > 60) return fail('Kalkulator ini menggunakan standar balita WHO: umur harus antara 0 dan 60 bulan.');
      if (isNaN(h)) return fail('Tinggi atau panjang badan belum diisi.');
      if (h < 30 || h > 140) return fail('Tinggi badan tampak di luar rentang wajar (30–140 cm). Mohon periksa kembali angkanya.');

      show(sex, age, h, (elName.value || '').trim());
    });

    $('#calcReset').addEventListener('click', function () {
      form.reset();
      err.hidden = true;
      out.hidden = true;
      empty.hidden = false;
    });

    function show(sex, age, h, name) {
      var ref = D.whoRef(sex, age);
      var z = (h - ref.median) / ref.sd;
      var cls = D.classify(z);
      var pct = D.zToPercentile(z);

      empty.hidden = true;
      out.hidden = false;

      var v = $('#verdict');
      v.dataset.tone = cls.tone;
      $('#verdictIcon').textContent = cls.icon;
      $('#verdictText').textContent = cls.label;
      $('#verdictDesc').textContent = (name ? name + ' — ' : '') + cls.desc;

      $('#zVal').textContent = (z >= 0 ? '+' : '') + z.toFixed(2);
      $('#zMedian').textContent = ref.median.toFixed(1) + ' cm';
      var diff = h - ref.median;
      $('#zDiff').textContent = (diff >= 0 ? '+' : '') + diff.toFixed(1) + ' cm';
      $('#zPct').textContent = (pct < 1 ? '<1' : pct > 99 ? '>99' : Math.round(pct)) + '%';

      // penanda pada skala −4 … +3 (lebar segmen: 1,1,4,1 → total 7)
      var zc = clamp(z, -4, 3);
      $('#zMarker').style.left = ((zc + 4) / 7) * 100 + '%';
      $('#zMarkerVal').textContent = (z >= 0 ? '+' : '') + z.toFixed(1);

      var adv = $('#advice');
      adv.innerHTML = '<h4>Langkah yang disarankan</h4>' +
        D.adviceFor(cls.key, age).map(function (a) {
          return '<div class="advice__item"><i>→</i><span><b>' + a[0] + '</b> — ' + a[1] + '</span></div>';
        }).join('');

      drawChart(sex, age, h, cls);
      out.scrollIntoView({ behavior: REDUCED ? 'auto' : 'smooth', block: 'nearest' });
    }

    /* ── kurva pertumbuhan SVG ── */
    var W = 720, H = 380, L = 56, R = 20, T = 22, B = 44;
    var Y0 = 40, Y1 = 125;   // rentang cm
    var X1 = 60;             // rentang bulan

    var xs = function (m) { return L + (m / X1) * (W - L - R); };
    var ys = function (cm) { return T + (1 - (cm - Y0) / (Y1 - Y0)) * (H - T - B); };

    function path(sex, z) {
      var d = '';
      for (var m = 0; m <= X1; m += 1) {
        d += (m ? 'L' : 'M') + xs(m).toFixed(1) + ' ' + ys(D.heightAtZ(sex, m, z)).toFixed(1) + ' ';
      }
      return d.trim();
    }

    function drawChart(sex, age, h, cls) {
      var svg = $('#growthChart');
      var g = '';

      // pita normal −2SD … +2SD
      var band = 'M';
      for (var m = 0; m <= X1; m++) band += (m ? 'L' : '') + xs(m).toFixed(1) + ' ' + ys(D.heightAtZ(sex, m, 2)).toFixed(1) + ' ';
      for (var k = X1; k >= 0; k--) band += 'L' + xs(k).toFixed(1) + ' ' + ys(D.heightAtZ(sex, k, -2)).toFixed(1) + ' ';
      band += 'Z';
      g += '<path class="gc-band" d="' + band + '"/>';

      // grid
      for (var cm = Y0; cm <= Y1; cm += 10) {
        g += '<line class="gc-grid" x1="' + L + '" y1="' + ys(cm) + '" x2="' + (W - R) + '" y2="' + ys(cm) + '"/>';
        g += '<text class="gc-label" x="' + (L - 10) + '" y="' + (ys(cm) + 4) + '" text-anchor="end">' + cm + '</text>';
      }
      for (var mm = 0; mm <= X1; mm += 6) {
        g += '<line class="gc-grid" x1="' + xs(mm) + '" y1="' + T + '" x2="' + xs(mm) + '" y2="' + (H - B) + '"/>';
        g += '<text class="gc-label" x="' + xs(mm) + '" y="' + (H - B + 20) + '" text-anchor="middle">' + mm + '</text>';
      }

      // sumbu
      g += '<line class="gc-axis" x1="' + L + '" y1="' + T + '" x2="' + L + '" y2="' + (H - B) + '"/>';
      g += '<line class="gc-axis" x1="' + L + '" y1="' + (H - B) + '" x2="' + (W - R) + '" y2="' + (H - B) + '"/>';
      g += '<text class="gc-title" x="' + ((W + L) / 2) + '" y="' + (H - 8) + '" text-anchor="middle">Umur (bulan)</text>';
      g += '<text class="gc-title" transform="rotate(-90 16 ' + (H / 2) + ')" x="16" y="' + (H / 2) + '" text-anchor="middle">Tinggi / panjang badan (cm)</text>';

      // kurva acuan
      g += '<path class="gc-line gc-p2" d="' + path(sex, 2) + '"/>';
      g += '<path class="gc-line gc-med" d="' + path(sex, 0) + '"/>';
      g += '<path class="gc-line gc-n2" d="' + path(sex, -2) + '"/>';
      g += '<path class="gc-line gc-n3" d="' + path(sex, -3) + '"/>';

      // titik anak
      var px = xs(clamp(age, 0, X1)), py = ys(clamp(h, Y0, Y1));
      g += '<line class="gc-grid" x1="' + px + '" y1="' + py + '" x2="' + px + '" y2="' + (H - B) + '" stroke="rgba(255,255,255,.25)" stroke-dasharray="3 4"/>';
      g += '<circle class="gc-pt-glow" cx="' + px + '" cy="' + py + '" r="13"/>';
      g += '<circle class="gc-pt" cx="' + px + '" cy="' + py + '" r="6"/>';
      g += '<text class="gc-legend" x="' + (px + 14) + '" y="' + (py - 12) + '" fill="#fff" font-weight="600">' + h.toFixed(1) + ' cm</text>';

      // keterangan
      var items = [
        ['#4a8cff', '+2 SD'], ['#3ddc84', 'Median'], ['#ff8a3d', '−2 SD (batas stunting)'], ['#ff5470', '−3 SD']
      ];
      var lx = L + 14, ly = T + 16;
      items.forEach(function (it, i) {
        var yy = ly + i * 17;
        g += '<line x1="' + lx + '" y1="' + yy + '" x2="' + (lx + 22) + '" y2="' + yy + '" stroke="' + it[0] + '" stroke-width="2.5" stroke-linecap="round"/>';
        g += '<text class="gc-legend" x="' + (lx + 30) + '" y="' + (yy + 4) + '">' + it[1] + '</text>';
      });

      svg.innerHTML = g;

      // animasi gambar kurva
      if (!REDUCED) {
        $$('.gc-line', svg).forEach(function (p, i) {
          var len = p.getTotalLength();
          p.style.strokeDasharray = len;
          p.style.strokeDashoffset = len;
          p.style.transition = 'stroke-dashoffset 1.1s cubic-bezier(.16,1,.3,1) ' + (i * 0.08) + 's';
          requestAnimationFrame(function () { p.style.strokeDashoffset = '0'; });
        });
      }
    }
  })();

  /* ═══════════ DAFTAR PERIKSA ═══════════ */
  (function checklist() {
    var grid = $('#checkGrid');
    if (!grid) return;
    var KEY = 'stunting_checklist_v1';
    var saved = {};
    try { saved = JSON.parse(localStorage.getItem(KEY) || '{}'); } catch (e) { saved = {}; }

    var fill = $('#checkFill'), pctOut = $('#checkPct');

    function sync() {
      var boxes = $$('.check input', grid);
      var n = boxes.filter(function (b) { return b.checked; }).length;
      var pct = Math.round((n / boxes.length) * 100);
      fill.style.width = pct + '%';
      pctOut.textContent = pct;
      try { localStorage.setItem(KEY, JSON.stringify(saved)); } catch (e) { /* mode privat */ }
    }

    D.CHECKLIST.forEach(function (c, i) {
      var id = 'chk' + i;
      var label = document.createElement('label');
      label.className = 'check reveal';
      label.innerHTML =
        '<input type="checkbox" id="' + id + '"' + (saved[id] ? ' checked' : '') + '>' +
        '<span class="check__box"><svg viewBox="0 0 24 24" fill="none"><path d="M4 12.5l5.5 5.5L20 7" stroke="currentColor" stroke-width="3.2" stroke-linecap="round" stroke-linejoin="round"/></svg></span>' +
        '<span class="check__txt"><b>' + c.t + '</b><span>' + c.d + '</span>' +
        '<span class="check__when">' + c.w + '</span></span>';
      label.querySelector('input').addEventListener('change', function (e) {
        saved[id] = e.target.checked;
        sync();
      });
      grid.appendChild(label);
    });
    sync();
  })();

  /* ═══════════ KUIS ═══════════ */
  (function quiz() {
    var root = $('#quiz');
    if (!root) return;

    var qText = $('#qText'), qOpts = $('#qOpts'), qFb = $('#qFeedback'), qNext = $('#qNext');
    var body = $('#quizBody'), done = $('#quizDone');
    var idx = 0, score = 0, answered = false;

    $('#qTotal').textContent = D.QUIZ.length;

    function render() {
      var q = D.QUIZ[idx];
      answered = false;
      qText.textContent = q.q;
      qFb.hidden = true;
      qNext.hidden = true;
      qOpts.innerHTML = '';
      $('#qNum').textContent = idx + 1;
      $('#qScore').textContent = score;
      $('#quizFill').style.width = (idx / D.QUIZ.length) * 100 + '%';

      q.o.forEach(function (opt, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'qopt';
        b.innerHTML = '<i>' + 'ABCD'[i] + '</i><span>' + opt + '</span>';
        b.addEventListener('click', function () { answer(i, b); });
        qOpts.appendChild(b);
      });
    }

    function answer(i, btn) {
      if (answered) return;
      answered = true;
      var q = D.QUIZ[idx];
      var ok = i === q.a;
      if (ok) score++;

      $$('.qopt', qOpts).forEach(function (b, j) {
        b.disabled = true;
        if (j === q.a) b.classList.add('correct');
        else if (j === i) b.classList.add('wrong');
        else b.classList.add('faded');
      });

      qFb.hidden = false;
      qFb.dataset.ok = ok ? '1' : '0';
      qFb.innerHTML = '<b>' + (ok ? '✓ Tepat sekali' : '✗ Belum tepat') + '</b>' + q.e;
      qNext.hidden = false;
      qNext.textContent = idx === D.QUIZ.length - 1 ? 'Lihat Hasil' : 'Lanjut';
      $('#qScore').textContent = score;
    }

    qNext.addEventListener('click', function () {
      if (idx < D.QUIZ.length - 1) { idx++; render(); }
      else finish();
    });

    function finish() {
      body.hidden = true;
      done.hidden = false;
      $('#quizFill').style.width = '100%';
      $('#finalScore').textContent = score;

      var res = D.QUIZ_RESULTS.filter(function (r) { return score >= r.min; }).pop() || D.QUIZ_RESULTS[0];
      $('#finalTitle').textContent = res.t;
      $('#finalDesc').textContent = res.d;

      var C = 327;
      var ring = $('#scoreRing');
      ring.style.strokeDashoffset = C;
      requestAnimationFrame(function () {
        ring.style.strokeDashoffset = C - C * (score / D.QUIZ.length);
      });
      ring.style.stroke = score >= 6 ? '#3ddc84' : score >= 4 ? '#ffb648' : '#ff5470';
    }

    $('#qRestart').addEventListener('click', function () {
      idx = 0; score = 0;
      body.hidden = false;
      done.hidden = true;
      render();
    });

    render();
  })();

  /* ═══════════ FAQ ═══════════ */
  (function faq() {
    var list = $('#faqList');
    if (!list) return;

    D.FAQ.forEach(function (f, i) {
      var item = document.createElement('div');
      item.className = 'faq__item reveal';
      item.innerHTML =
        '<button class="faq__q" aria-expanded="false" aria-controls="faqa' + i + '">' +
          '<span>' + f.q + '</span>' +
          '<svg viewBox="0 0 24 24" fill="none"><path d="M12 5v14M5 12h14" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>' +
        '</button>' +
        '<div class="faq__a" id="faqa' + i + '"><p>' + f.a + '</p></div>';

      var btn = item.querySelector('.faq__q');
      var panel = item.querySelector('.faq__a');

      btn.addEventListener('click', function () {
        var open = item.classList.toggle('open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        panel.style.height = open ? panel.scrollHeight + 'px' : '0px';

        if (open) {
          $$('.faq__item.open', list).forEach(function (other) {
            if (other === item) return;
            other.classList.remove('open');
            other.querySelector('.faq__q').setAttribute('aria-expanded', 'false');
            other.querySelector('.faq__a').style.height = '0px';
          });
        }
      });
      list.appendChild(item);
    });

    // jawaban yang terbuka harus ikut menyesuaikan tinggi saat lebar berubah
    var rt;
    window.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(function () {
        $$('.faq__item.open', list).forEach(function (it) {
          var panel = it.querySelector('.faq__a');
          panel.style.transition = 'none';
          panel.style.height = 'auto';
          var h = panel.offsetHeight;
          panel.style.height = h + 'px';
          requestAnimationFrame(function () { panel.style.transition = ''; });
        });
      }, 120);
    });
  })();

  /* ═══════════ MULAI ═══════════ */
  // Reveal & counter sengaja ditahan sampai preloader selesai, supaya animasi
  // hero tidak habis diputar di balik layar muat. Bila preloader tidak ada
  // (mis. dihapus dari markup), jalankan langsung.
  if (!$('#preloader')) kickReveal();
})();
